<template>
  <div class="wrapper">
    <Modal width="750" ok-text="" v-model="seeModal" title="课件列表">
      <Table
        :columns="tableColumns"
        :data="seeDetailList"
        border
        style="margin-top: 20px"
      >
      </Table>
      <Page
        style="text-align: right; margin-top: 20px"
        :total="tableData.total"
        :page-size="tableData.per_page"
        :current="tableData.current_page"
        show-total
        @on-change="getData"
      />
      <div slot="footer"></div>
    </Modal>
  </div>
</template>
<script>
import indexPage from "../../mixins/indexPage";
import { mapState } from "vuex";
export default {
  computed: {
    ...mapState({
      gradeList(state) {
        return state.global.gradeList;
      },
      subjectList(state) {
        return state.global.subjectList;
      },
      curseList(state) {
        return state.global.curseList;
      }
    })
  },
  data() {
    return {
      seeModal: false,
      storageParams: {},
      /**/
      storage_id: 0,
      grade_id: 0,
      subject_id: 0,
      course_id: 0,
      /**/
      tableData: {
        total: 0,
        per_page: 10,
        current_page: 1,
        last_page: 1
      },
      seeDetailList: [], // 课程下课件列表
      tableColumns: [
        { title: "课件", key: "name", align: "center" },
        { title: "课件库", key: "storage_name", align: "center" },
        {
          title: "科目",
          key: "subject_id",
          align: "center",
          render: (h, params) => {
            let [str, id] = ["", params.row.subject_id];
            this.subjectList.forEach(ele => {
              if (ele.id == id) {
                str = ele.name;
              }
            });
            return h("div", str);
          }
        },
        {
          title: "课程",
          key: "course_id",
          align: "center",
          render: (h, params) => {
            let [str, id] = ["", params.row.course_id];
            this.curseList.forEach(ele => {
              if (ele.id == id) {
                str = ele.name;
              }
            });
            return h("div", str);
          }
        },
        {
          title: "下载",
          align: "center",
          render: (h, params) => {
            return h(
              "span",
              {
                on: {
                  click: () => {
                    this.getFile(params);
                  }
                },
                style: {
                  color: "#57a3f3",
                  cursor: "pointer"
                }
              },
              params.row.name
            );
          }
        }
      ]
    };
  },
  mixins: [indexPage],
  components: {},
  mounted() {},
  methods: {
    dows(url, filename) {
      if (!url) {
        this.$Message.error("下载地址不存在");
        return;
      }

      const serverDomain = process.env.VUE_APP_SERVER_DOMAIN.replace(/\/+$/, "");
      const fileUrl = /^(?:https?:)?\/\//i.test(url)
        ? url
        : `${serverDomain}/${url.replace(/^\/+/, "")}`;
      const extension = url.split(/[?#]/)[0].match(/\.[^./\\]+$/);
      const downloadName = filename && extension && !filename.endsWith(extension[0])
        ? `${filename}${extension[0]}`
        : filename;
      const downloadElement = document.createElement("a");
      downloadElement.href = fileUrl;
      downloadElement.download = downloadName || "";
      downloadElement.target = "_blank";
      downloadElement.rel = "noopener";
      document.body.appendChild(downloadElement);
      downloadElement.click();
      document.body.removeChild(downloadElement);
    },
    getFile(params) {
      this.dows(params.row.file, params.row.name);
    },

    getDetail(row) {
      this.storageRow = row;
      this.seeModal = true;
      /*cjp 2023.7.15*/
      this.storage_id = row.id;
      this.grade_id = row.grade_id;
      this.subject_id = row.subject_id;
      this.course_id = row.course_id;
      this.getData(1);
    },
    /**/
    getData(page) {
      let data = {
        storage_id: this.storage_id,
        grade_id: this.grade_id,
        subject_id: this.subject_id,
        course_id: this.course_id,
        current: this.tableData.current_page,
        page: page
      };
      this.$axios.get("/app/source_courseware/index", data).then(res => {
        if (res.code == 1) {
          this.tableData.total = res.data.total;
          this.seeDetailList = res.data.data;
        }
      });
    }
  }
};
</script>
<style scoped lang="less">
/deep/ .ivu-modal {
  width: 80% !important;
}
</style>
